import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceUser } from '../../domain/model/resource-user';

@Injectable({
    providedIn: 'root',
})
export class ResourceUserService {

    private http = inject(HttpClient);

    public getUsers(): Observable<ResourceUser[]> {
        return this.http.get<ResourceUser[]>(environment.API_URL + '/admin/resource_user');
    }

    public getUserByUsername(userName: string): Observable<ResourceUser> {
        return this.http.get<ResourceUser>(environment.API_URL + '/admin/resource_user/' + userName);
    }

    public saveUser(user: ResourceUser): Observable<ResourceUser> {
        return this.http.post<ResourceUser>(environment.API_URL + '/admin/resource_user', user);
    }

    public updateUser(userName: string, user: ResourceUser): Observable<ResourceUser> {
        return this.http.put<ResourceUser>(environment.API_URL + '/admin/resource_user/' + userName, user);
    }

    public deleteUser(userName: string) {
        return this.http.delete<ResourceUser>(environment.API_URL + '/admin/resource_user/' + userName);
    }
}
